/* CE:I18N V2 — CollectorElysium French Translation (non-invasive)
   Only activates when Shopify.locale === 'fr'
   English version is NEVER touched */
(function(){
try {
  var lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
  if (lang !== 'fr') return;

  /* ── Translation Dictionary ── */
  var T = {
    /* Hero */
    'The Luxury Marketplace': 'The Luxury Marketplace', /* brand — keep */
    'Find your next': 'Trouvez votre prochaine',
    'exceptional': 'pièce',
    'Piece': 'exceptionnelle',
    'Piece.': 'exceptionnelle.',

    /* Hero tagline */
    'Hermes, Chanel, Rolex — Buy, Sell, Discover.': 'Hermès, Chanel, Rolex — Achetez, Vendez, Découvrez.',
    'Hermes, Chanel, Rolex — Achetez, Vendez, Découvrez.': 'Hermès, Chanel, Rolex — Achetez, Vendez, Découvrez.',

    /* Hero search */
    'All categories': 'Toutes les catégories',

    /* Hero stats */
    'Authentic': 'Authentique',
    'Delivery': 'Livraison',
    'Collectors': 'Collectionneurs',

    /* Trust bar (CSS makes uppercase, DOM is title-case) */
    'Certified Authentication': 'Authentification Certifiée',
    'Secure delivery': 'Livraison Sécurisée',
    'Secure payment': 'Paiement Sécurisé',
    'Private Concierge 7/7': 'Conciergerie Privée 7/7',

    /* "Where rarity meets timeless elegance" section (split nodes) */
    'Where': 'Où',
    'rarity': 'la rareté',
    'meets': 'rencontre',
    'timeless elegance': "l'élégance intemporelle",
    'Each piece in our collection is hand-selected for its exceptional condition, provenance, and investment potential. Welcome to a curated world where rarity has value.':
      'Chaque pièce de notre collection est sélectionnée pour sa condition exceptionnelle, sa provenance et son potentiel d\'investissement. Bienvenue dans un univers curé où la rareté a de la valeur.',
    'Each piece in our collection is hand-selected for its exceptional condition, provenance, and investment potential. Welcome to a new standard in luxury resale.':
      'Chaque pièce de notre collection est sélectionnée pour sa condition exceptionnelle, sa provenance et son potentiel d\'investissement. Bienvenue dans un nouveau standard de la revente de luxe.',

    /* Just Listed */
    'Just Listed by Our Collectors': 'Dernières pièces de nos Collectionneurs',

    /* Badges (CSS uppercase, DOM is title-case) */
    'Sold': 'Vendu',
    'New': 'Nouveau',

    /* Expert Insights */
    'Expert Insights & Market Intelligence': 'Analyses & Intelligence du Marché',

    /* VIEW ALL */
    'VIEW ALL': 'TOUT VOIR',
    'View all': 'Tout voir',
    'View All': 'Tout Voir',

    /* Piece of the Week */
    'Piece of the Week': 'Pièce de la Semaine',
    'View This Piece': 'Voir cette Pièce',
    'Explore the Full Collection': 'Explorer la Collection',

    /* Expert / curated by */
    'Curated by': 'Sélectionné par',
    'Curated by Alexandre M.': 'Sélectionné par Alexandre M.',

    /* Stats section (lower) */
    'Pieces Sold': 'Pièces Vendues',
    'Authenticated': 'Authentifiées',
    'Countries Served': 'Pays Desservis',
    'Client Rating': 'Note Client',

    /* Journal section */
    'Market': 'Marché', 'Market Insights': 'Marché', 'Heritage': 'Héritage', 'Marketplace': 'Marketplace',
    'Luxury investment analysis, authentication expertise, and the art of collecting.':
      "Analyses d'investissement luxe, expertise en authentification et l'art de collectionner.",

    /* Blog article titles */
    "The Hermès Constance: The Discreet Icon of Faubourg Saint-Honoré":
      "L'Hermès Constance : L'Icône Discrète du Faubourg Saint-Honoré",
    'The Art of Luxury Consignment: How to Sell Your Designer Pieces':
      "L'Art de la Consignation de Luxe : Comment Vendre vos Pièces de Créateur",
    'Hermès Birkin 25 vs 30 vs 35: Choosing Your Perfect Size':
      'Hermès Birkin 25 vs 30 vs 35 : Choisir la Taille Parfaite',

    /* Blog snippets */
    'COLLECTOR': 'COLLECTIONNEUR',
    'BIRKIN': 'BIRKIN',

    /* Blog excerpts — match first ~80 chars for replacement */

    /* Sourcing / CTA section */
    'Consign With Us': 'Déposer en Consignation',
    'Private Sourcing': 'Sourcing Privé',
    'Looking for a Specific Piece?': 'Vous cherchez une pièce spécifique ?',
    'Our sourcing team specializes in finding rare and exceptional pieces for discerning collectors. From limited-edition Birkins to vintage Chanel, we leverage our global network to locate exactly what you desire.':
      'Notre équipe de sourcing est spécialisée dans la recherche de pièces rares et exceptionnelles pour les collectionneurs exigeants. Des Birkin en édition limitée aux Chanel vintage, nous mobilisons notre réseau mondial pour trouver exactement ce que vous désirez.',
    'Our sourcing team specializes in finding rare and exceptional pieces for discerning collectors. From limited-edition Birkins to vintage haute horlogerie, tell us what you are looking for.':
      'Notre équipe de sourcing est spécialisée dans la recherche de pièces rares et exceptionnelles pour les collectionneurs exigeants. Des Birkin en édition limitée à la haute horlogerie vintage, dites-nous ce que vous recherchez.',

    /* Install App */
    'Install our Beta App': 'Installer notre App Beta',
    'Save 20%': 'Économisez 20%',

    /* Product page */
    'EXCLUSIVE': 'EXCLUSIF',
    'NEW': 'NOUVEAU',
    'SOLD': 'VENDU',
    'ADD TO BAG': 'AJOUTER AU PANIER',
    'MAKE AN OFFER': 'FAIRE UNE OFFRE',
    'DESCRIPTION': 'DESCRIPTION',
    'OUR GUARANTEE & AUTHENTICATION PROCESS': "NOTRE GARANTIE & PROCESSUS D'AUTHENTIFICATION",
    'PROPOSED BY': 'PROPOSÉ PAR',
    'Authenticated & Certified by CollectorElysium — Included': 'Authentifié & Certifié par CollectorElysium — Inclus',
    'EXPERT VERIFIED': 'VÉRIFIÉ PAR UN EXPERT',
    'Multi-step authentication': 'Authentification multi-étapes',
    'BUYER PROTECTION': 'PROTECTION ACHETEUR',
    'Full refund guarantee': 'Garantie de remboursement',
    'INSURED SHIPPING': 'LIVRAISON ASSURÉE',
    'Worldwide with tracking': 'Mondial avec suivi',
    'CURATED SELECTION': 'SÉLECTION CURATÉE',
    'Only exceptional pieces': 'Uniquement des pièces exceptionnelles',
    'or 3 to 4 interest-free installments with': 'ou 3 à �4 fois sans frais avec',

    /* Account page */
    'MY ACCOUNT': 'MON COMPTE',
    'SIGN OUT': 'SE DÉCONNECTER',
    'COLLECTOR SPACE': 'ESPACE COLLECTIONNEUR',
    'Your Collector Space': 'Votre Espace Collectionneur',
    'Submit your pieces — we authenticate, curate and sell for you.': 'Soumettez vos pièces — Nous authentifions, sélectionnons et vendons pour vous.',
    'START SELLING': 'COMMENCER À VENDRE',
    'SELL A PIECE': 'VENDRE UNE PIÈCE',
    'ORDERS PLACED': 'COMMANDES PASSÉES',
    'TOTAL SPENT': 'TOTAL DÉPENSÉ',
    'SAVED ADDRESSES': 'ADRESSES ENREGISTRÉES',
    'ORDER HISTORY': 'HISTORIQUE DE COMMANDES',
    'ACCOUNT DETAILS': 'DÉTAILS DU COMPTE',
    'MANAGE ADDRESSES': 'GÉRER LES ADRESSES',
    'NAME': 'NOM',
    'EMAIL': 'E-MAIL',
    'DEFAULT ADDRESS': 'ADRESSE PAR DÉFAUT',
    'ADDRESSES': 'ADRESSES',
    'Welcome back,': 'Bienvenue,',

    /* Navigation (CSS uppercases — DOM is title-case) */
    'Collection': 'Collection',
    'Sell': 'Vendre',
    'Atelier': 'Atelier',
    'Journal': 'Journal',
    'Private': 'Privé',
    'About': 'À propos',
    'Contact': 'Contact',
    'COLLECTION': 'COLLECTION',
    'SELL': 'VENDRE',
    'ATELIER': 'ATELIER',
    'JOURNAL': 'JOURNAL',
    'PRIVATE': 'PRIVÉ',
    'ABOUT': 'À PROPOS',
    'CONTACT': 'CONTACT',

    /* Footer */
    'Let us guide you towards the extraordinary': "Laissez-nous vous guider vers l'extraordinaire",

    /* Breadcrumbs / misc */
    'Home': 'Accueil',
    'Collections': 'Collections',
    'Accessories': 'Accessoires',
    'Search': 'Rechercher',
    'Sort by': 'Trier par',
    'Newest first': 'Plus récents',
    'BRAND': 'MARQUE',
    'CATEGORY': 'CATÉGORIE',
    'View': 'Voir',
    'New Fullset': 'Fullset neuf',
    'Excellent': 'Excellent',
    'Very Good': 'Très bon',

    /* The Art of Collecting section */
    'The Art of Collecting': "L'Art de Collectionner",
    'PIECE OF THE WEEK': 'PIÈCE DE LA SEMAINE',
    "EDITOR'S CHOICE": 'COUP DE CŒUR',

    /* Also keep uppercase versions for elements that bypass CSS */
    'CERTIFIED AUTHENTICATION': 'AUTHENTIFICATION CERTIFIÉE',
    'SECURE DELIVERY': 'LIVRAISON SÉCURISÉE',
    'SECURE PAYMENT': 'PAIEMENT SÉCURISÉ',
    'PRIVATE CONCIERGE 7/7': 'CONCIERGERIE PRIVÉE 7/7',
    'ALL CATEGORIES': 'TOUTES LES CATÉGORIES',
    'AUTHENTIC': 'AUTHENTIQUE',
    'DELIVERY': 'LIVRAISON',
    'COLLECTORS': 'COLLECTIONNEURS',

    /* V4 patch — remaining untranslated elements */
    'View All →': 'Tout Voir →',
    'View All Articles →': 'Voir Tous les Articles →',
    'VIEW ALL ARTICLES →': 'VOIR TOUS LES ARTICLES →',
    'Quick View': 'Aperçu Rapide',
    'Read more': 'Lire la suite',
    'READ MORE': 'LIRE LA SUITE',
    'Private Concierge': 'Conciergerie Privée',
    'PRIVATE CONCIERGE': 'CONCIERGERIE PRIVÉE',
    'Shop Now': 'Acheter',
    'SHOP NOW': 'ACHETER',
    'Subscribe': 'S\'abonner',
    'Learn More': 'En savoir plus',
    'LEARN MORE': 'EN SAVOIR PLUS',
    'Send': 'Envoyer',
    'Get Started': 'Commencer',
    'Browse': 'Parcourir',
    'See All': 'Voir Tout',
    'SEE ALL': 'VOIR TOUT',
    'Add to Wishlist': 'Ajouter aux favoris',
    'ADD TO WISHLIST': 'AJOUTER AUX FAVORIS',
    'Notify Me': 'Me notifier',
    'NOTIFY ME': 'ME NOTIFIER',
    'Share': 'Partager',
    'SHARE': 'PARTAGER',
    'Size': 'Taille',
    'Color': 'Couleur',
    'Condition': 'État',
    'Material': 'Matière',
    'Year': 'Année',
    'Included': 'Inclus',
    'Price': 'Prix',
    'PRICE': 'PRIX',
    'Availability': 'Disponibilité',
    'In Stock': 'En stock',
    'SOLD OUT': 'ÉPUISÉ',
    'Sold out': 'Épuisée',
    'Coming Soon': 'Bientôt disponible',
    'Recently Viewed': 'Vus récemment',
    'You May Also Like': 'Vous aimerez aussi',
    'Related Products': 'Produits similaires',
    'Continue Shopping': 'Continuer vos achats',
    'CONTINUE SHOPPING': 'CONTINUER VOS ACHATS',
    'Your Cart': 'Votre Panier',
    'YOUR CART': 'VOTRE PANIER',
    'Subtotal': 'Sous-total',
    'Checkout': 'Passer commande',
    'CHECKOUT': 'PASSER COMMANDE',
    'Cart': 'Panier',
    'CART': 'PANIER',
    'Free Shipping': 'Livraison gratuite',
    'FREE SHIPPING': 'LIVRAISON GRATUITE',
    'Apply': 'Appliquer',
    'Remove': 'Supprimer',
    'Update': 'Mettre à jour',
    'Quantity': 'Quantité',
    'Total': 'Total',
    'Tax included.': 'Taxes incluses.',
    'Shipping calculated at checkout.': 'Frais de livraison calculés à la caisse.',

    /* V5 patch — product page missing elements */
    'ADD TO BAG': 'AJOUTER AU PANIER',
    'Add to bag': 'Ajouter au panier',
    'Add to Bag': 'Ajouter au Panier',
    'MAKE AN OFFER': 'FAIRE UNE OFFRE',
    'Make an Offer': 'Faire une Offre',
    'Make an offer': 'Faire une offre',
    'PROPOSED BY': 'PROPOSÉ PAR',
    'Proposed by': 'Proposé par',
    'Proposed By': 'Proposé Par',
    'OUR GUARANTEE & AUTHENTICATION PROCESS': "NOTRE GARANTIE & PROCESSUS D'AUTHENTIFICATION",
    'Our Guarantee & Authentication Process': "Notre Garantie & Processus d'Authentification",
    'EXPERT VERIFIED': 'VÉRIFIÉ PAR UN EXPERT',
    'Expert Verified': 'Vérifié par un Expert',
    'BUYER PROTECTION': 'PROTECTION ACHETEUR',
    'Buyer Protection': 'Protection Acheteur',
    'INSURED SHIPPING': 'LIVRAISON ASSURÉE',
    'Insured Shipping': 'Livraison Assurée',
    'CURATED SELECTION': 'SÉLECTION CURATÉE',
    'Curated Selection': 'Sélection Curatée',
    'EXPERT ASSESSMENT': 'AVIS D\'EXPERT',
    'Expert Assessment': 'Avis d\'Expert',
    'Horology Expert': 'Expert Horloger',
    'Verified Expert': 'Expert Vérifié',
    'Heritage:': 'Héritage :',
    'Craftsmanship:': 'Savoir-faire :',
    'Investment Outlook:': 'Potentiel d\'investissement :',
    'Collector\'s Note:': 'Note du Collectionneur :',
    'BUY NOW': 'ACHETER MAINTENANT',
    'Buy Now': 'Acheter Maintenant',
    'Buy now': 'Acheter maintenant',

    /* V5 patch — collection page filters & sourcing card */
    'BRAND': 'MARQUE',
    'Brand': 'Marque',
    'ALL': 'TOUT',
    'All': 'Tout',
    'Very good': 'Très bon',
    'Good': 'Bon',
    'Min': 'Min',
    'Max': 'Max',
    "Can't find it?": 'Vous ne trouvez pas ?',
    'Our concierge sources the rarest pieces worldwide — just tell us what you\'re looking for.': 'Notre conciergerie source les pièces les plus rares au monde — dites-nous ce que vous cherchez.',
    'REQUEST': 'DEMANDE',
    'Request': 'Demande',
    'SOURCING': 'SOURCING',
    'REQUEST SOURCING': 'DEMANDER UN SOURCING',

    /* V5 patch — homepage remaining */
    "EDITOR'S CHOICE": 'COUP DE CŒUR',
    "Editor's Choice": 'Coup de Cœur',
    "Editor's choice": 'Coup de cœur',

    /* V5 patch — product variant labels in cart */
    'Size:': 'Taille :',
    'Color:': 'Couleur :',
    'Material:': 'Matière :',

    /* V5 patch — blog excerpts (partial match for long texts) */
    'In a world captivated by the Birkin and the Kelly, there exists a third Hermès bag that true conn': "Dans un monde captivé par le Birkin et le Kelly, il existe un troisième sac Hermès que les vrais conn",
    'Selling a luxury piece is a deeply personal decision. Whether you are evolving your collection, f': "Vendre une pièce de luxe est une décision profondément personnelle. Que vous fassiez évoluer votre collection, f",
    'Choosing the right Birkin size is one of the most important decisions a collector will make. Each': "Choisir la bonne taille de Birkin est l'une des décisions les plus importantes pour un collectionneur. Chaque",

    /* V5 patch — misc product page */
    'Automatic': 'Automatique',
    'Yellow Gold': 'Or Jaune',
    'Rose Gold': 'Or Rose',
    'White Gold': 'Or Blanc',
    'Steel': 'Acier',
    'Stainless Steel': 'Acier Inoxydable',
    'Leather': 'Cuir',
    'Canvas': 'Toile',
    'Palladium': 'Palladium',
    'Gold': 'Or',
    'Silver': 'Argent',
    'Platinum': 'Platine',
    'Porosus Crocodile': 'Crocodile Porosus',
    'Niloticus Crocodile': 'Crocodile Niloticus',
    'Togo': 'Togo',
    'Epsom': 'Epsom',
    'Swift': 'Swift',
    'Clemence': 'Clémence',
    'Box Calf': 'Box Calf',
    'Ostrich': 'Autruche',
    'Alligator': 'Alligator',
    'Lizard': 'Lézard',

    /* V5 patch — page titles */
    'Page not found': 'Page non trouvée',
    'Continue shopping': 'Continuer les achats',

    /* V5 patch — search rotating placeholders */
    'Search for an item': 'Rechercher un article',
    'Search for a Chanel Classic Flap...': 'Rechercher un Chanel Classic Flap...',
    'Search for a Rolex Submariner...': 'Rechercher une Rolex Submariner...',
    'Search for a Hermès Birkin...': 'Rechercher un Hermès Birkin...',
    'Search for a Hermès Kelly...': 'Rechercher un Hermès Kelly...',

    /* V5 patch — product badges context */
    'Exclusive': 'Exclusif',

    /* V5 patch — estimated total */
    'Estimated total': 'Total estimé',
    'ESTIMATED TOTAL': 'TOTAL ESTIMÉ'
  };

  /* ── Placeholders ── */
  var placeholders = {
    'Search for an item..': 'Rechercher un article..',
    'Search for an item...': 'Rechercher un article...',
    'Search for a Louis Vuitton Capucines...': 'Rechercher une Louis Vuitton Capucines...',
    'Search for a Chanel Classic Flap...': 'Rechercher un Chanel Classic Flap...',
    'Search for a Rolex Submariner...': 'Rechercher une Rolex Submariner...',
    'Search for a Hermès Birkin...': 'Rechercher un Hermès Birkin...',
    'Search for a Hermès Kelly...': 'Rechercher un Hermès Kelly...',
    'Search': 'Rechercher',
    'E-mail': 'E-mail',
    'Min €': 'Min €',
    'Max €': 'Max €'
  };

  /* ── DOM Walker ── */
  function walkText(node) {
    if (node.nodeType === 3) {
      var raw = node.textContent;
      var txt = raw.trim();
      if (txt && T[txt] && T[txt] !== txt) {
        node.textContent = raw.replace(txt, T[txt]);
      } else if (txt) {
        /* Partial match for long paragraphs — check if text starts with a known key */
        for (var key in T) {
          if (key.length > 40 && txt.indexOf(key) === 0) {
            node.textContent = raw.replace(key, T[key]);
            break;
          }
        }
      }
    } else if (node.nodeType === 1 && node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE' && node.tagName !== 'NOSCRIPT') {
      for (var i = 0; i < node.childNodes.length; i++) {
        walkText(node.childNodes[i]);
      }
    }
  }

  /* ── Translate select options ── */
  function translateSelects() {
    document.querySelectorAll('select option').forEach(function(opt) {
      var t = opt.textContent.trim();
      if (T[t]) opt.textContent = T[t];
    });
  }

  /* ── Translate placeholders ── */
  function translatePlaceholders() {
    document.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function(el) {
      var ph = el.getAttribute('placeholder');
      if (placeholders[ph]) el.setAttribute('placeholder', placeholders[ph]);
    });
  }

  /* ── Translate inline labels (e.g. "Size: 25" → "Taille : 25") ── */
  var inlineLabels = {
    'Size:': 'Taille :',
    'Color:': 'Couleur :',
    'Material:': 'Matière :',
    'Colour:': 'Couleur :',
    'Style:': 'Style :'
  };
  function translateInlineLabels(node) {
    if (node.nodeType === 3) {
      var txt = node.textContent;
      for (var en in inlineLabels) {
        if (txt.indexOf(en) !== -1) {
          node.textContent = txt.replace(en, inlineLabels[en]);
        }
      }
    } else if (node.nodeType === 1 && node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') {
      for (var i = 0; i < node.childNodes.length; i++) {
        translateInlineLabels(node.childNodes[i]);
      }
    }
  }

  /* ── Main translate ── */
  var _i18nTranslating = false;
  function translatePage() {
    if (_i18nTranslating) return;
    _i18nTranslating = true;
    walkText(document.body);
    translateInlineLabels(document.body);
    translateSelects();
    translatePlaceholders();
    _i18nTranslating = false;
  }

  /* ── Run ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      translatePage();
      setTimeout(translatePage, 500);
      setTimeout(translatePage, 1500);
      setTimeout(translatePage, 3500); /* catch counter animations */
    });
  } else {
    translatePage();
    setTimeout(translatePage, 500);
    setTimeout(translatePage, 1500);
    setTimeout(translatePage, 3500); /* catch counter animations */
  }

  /* ── MutationObserver for dynamic content ── */
  var _i18nDebounce;
  var observer = new MutationObserver(function(mutations) {
    if (_i18nTranslating) return; /* skip mutations triggered by our own translations */
    var needsWalk = false;
    mutations.forEach(function(m) {
      if (m.type === 'characterData') {
        /* Text node changed in-place (counter animations, lazy-loaded text) */
        var txt = m.target.textContent.trim();
        if (txt && T[txt] && T[txt] !== txt) {
          _i18nTranslating = true;
          m.target.textContent = m.target.textContent.replace(txt, T[txt]);
          _i18nTranslating = false;
        }
      } else {
        m.addedNodes.forEach(function(n) {
          if (n.nodeType === 1 || n.nodeType === 3) needsWalk = true;
        });
      }
    });
    if (needsWalk) {
      clearTimeout(_i18nDebounce);
      _i18nDebounce = setTimeout(translatePage, 50);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  /* ── Webkul locale sync: append &locale=fr to seller portal links ── */
  function tagWebkulLinks() {
    var links = document.querySelectorAll('a[href*="sp-seller.webkul.com"], a[href*="seller.collectorelysium.com"]');
    links.forEach(function(a) {
      if (a.href.indexOf('locale=') === -1) {
        a.href += (a.href.indexOf('?') !== -1 ? '&' : '?') + 'locale=fr';
      }
    });
  }
  tagWebkulLinks();
  /* Also tag links that appear dynamically */
  var webkulObserver = new MutationObserver(function() { tagWebkulLinks(); });
  webkulObserver.observe(document.body, { childList: true, subtree: true });

} catch(e) { console.warn('CE:I18N error:', e); }
})();
